<ng-container *transloco="let translate">
	@if (
		{
			collapsed: sidenavService.collapsed$ | async,
			user: user$ | async,
			quota: quota$ | async,
			isDesktop: isDesktop$ | async,
		};
		as vm
	) {
		<div
			[class]="vm.isDesktop && vm.collapsed ? '' : 'pl-0.5'"
			[class.p-0]="vm.isDesktop && vm.collapsed"
			[class.justify-between]="!vm.collapsed"
			[class.justify-center]="vm.collapsed"
			class="w-full flex items-center box-border"
			[class.pr-1]="!vm.collapsed"
		>
			<div
				#mainAnchor
				class="sidenav-logo"
				[class.sidenav-logo--with-title]="useIconWithTitleInSideNav"
				[class.sidenav-logo--collapsed]="vm.collapsed"
			>
				<ng-container *ngIf="useIconWithTitleInSideNav; else defaultSideNavLogo">
					<div class="gap-1 w-full flex items-center">
						<img
							class="flex-none logo-image w-4 h-4"
							src="/assets/images/logo/logo.png"
							alt="Logo"
						/>
						<p class="flex-auto truncate logo-image">
							{{ appTitle }}
						</p>
					</div>
				</ng-container>
				<ng-template #defaultSideNavLogo>
					<span class="logo-image p-0.5">
						<img
							class="w-12"
							src="/assets/images/logo/logo-with-text.png"
							alt="myReach"
						/>
					</span>
				</ng-template>
			</div>
			<button
				uiNewButtonIcon
				(click)="toggleCollapsedStatus()"
				[tooltip]="
					!vm.collapsed
						? translate('home.side_navigation.hide_sidenav')
						: translate('home.side_navigation.expand_sidenav')
				"
			>
				<i
					class="icon-double-chevron text-icon-s"
					[class.chevron-right]="vm.collapsed"
					[class.chevron-left]="!vm.collapsed"
				></i>
			</button>
		</div>
	}
</ng-container>
